import { useState, useEffect } from "react";
import { useToast } from "@chakra-ui/react"; // Importer riktig toast-hook
import { useUserInfo, useUser } from "../api/hooks";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

function PrivateRoute() {
  const { data: userInfo, isLoading } = useUserInfo();
  const { data: user, isLoading: isUserLoading } = useUser();
  const toast = useToast();
  const [isUserInfoLoaded, setIsUserInfoLoaded] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsUserInfoLoaded(true);
    }
  }, [isLoading]);

  useEffect(() => {
    if (isUserInfoLoaded && !userInfo?.isAuthenticated) {
      toast({
        title: "Du må logge inn",
        description: "Siden krever at du er innlogget",
        status: "info",
        isClosable: true,
        position: "top",
      });
    }
  }, [isUserInfoLoaded, userInfo, toast]);

  if (!isUserInfoLoaded || (userInfo?.isAuthenticated && isUserLoading)) {
    // Du kan returnere en loader her hvis du ønsker å vise en lasteskjerm
    return <div>Laster...</div>;
  }

  // Innlogget i HelseID, men ikke registrert som bruker: forsiden viser melding om manglende tilgang
  return (
    <>
      {userInfo?.isAuthenticated && !!user ? (
        <Outlet />
      ) : (
        <Navigate to={"/"} />
      )}
    </>
  );
}

export default PrivateRoute;
